import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useI18n } from "../../../i18n";
import { fmtMoney } from "../../../lib/format";
import { pct } from "../../../lib/xutil";
import { useApi, useCategories } from "../../customer/hooks";
import { Panel } from "../../../components/common/Page";
import { SkeletonBlock } from "../../../components/common/EmptyState";
import { BLUE, NAVY } from "../../customer/insights/Charts";

export const MarginPanel = ({ code, range }) => {
  const { t, lang } = useI18n();
  const cats = useCategories();
  const r = useApi("margin", `/staff/customers/${encodeURIComponent(code)}/margin`, { date_from: range.from, date_to: range.to }, { enabled: range.from <= range.to });
  if (r.isLoading) return <SkeletonBlock className="h-48" />;
  if (!r.data) return null;
  const { total, by_category: byCat, monthly } = r.data;
  const catName = (c) => (cats.data || []).find((x) => x.code === c)?.[`name_${lang}`] || c;
  return (
    <Panel title={`${t("x.cust.margin")} · ${pct(total.margin_pct)}`} sub={t("x.cust.marginNote")} testId="margin-panel">
      <div className="grid grid-cols-3 gap-3 text-sm">
        {[["revenue", total.revenue], ["cost", total.cost], ["margin", total.margin]].map(([k, v]) => (
          <div key={k} className="rounded-xl bg-canvas p-3"><p className="text-xs text-slate-500">{t(`x.cust.${k}`)}</p><p className="font-semibold tabular-nums text-navy" data-testid={`margin-${k}`}>{fmtMoney(v)}</p></div>
        ))}
      </div>
      <div className="mt-4 h-48">
        <ResponsiveContainer><BarChart data={monthly}><CartesianGrid vertical={false} stroke="#eef1f4" /><XAxis dataKey="key" tick={{ fontSize: 11 }} /><YAxis tick={{ fontSize: 11 }} width={50} />
          <Tooltip formatter={(v) => fmtMoney(v)} /><Bar dataKey="revenue" name={t("x.cust.revenue")} fill={NAVY} radius={[4, 4, 0, 0]} /><Bar dataKey="margin" name={t("x.cust.margin")} fill={BLUE} radius={[4, 4, 0, 0]} /></BarChart></ResponsiveContainer>
      </div>
      <ul className="mt-3 divide-y divide-slate-100 text-sm" data-testid="margin-by-category">
        {byCat.map((s) => <li key={s.key} className="flex justify-between gap-2 py-2"><span className="truncate text-navy">{catName(s.key)}</span><span className="tabular-nums text-slate-600">{fmtMoney(s.margin)} · <b className="text-navy">{pct(s.margin_pct)}</b></span></li>)}
      </ul>
    </Panel>
  );
};
